import React from "react";
import { useTranslation } from "react-i18next";

interface DescriptionProps {
    className?: string;
    description?: string;
}

const Description: React.FunctionComponent<DescriptionProps> = ({
    className = "description",
    description
}) => {
    const { t } = useTranslation();
    return (
        <div className={className}>
            <p> {t(`${description}`)} </p>
        </div>
    );
};

export default Description;
